module.exports = __webpack_public_path__ + "img/证书6.1ef41f16.jpg";